module.exports = __webpack_public_path__ + "static/media/nk-logo.762d9ec0.png";